/**
 * Global font-size preference (Feedback A7: "use a bigger font"). Carbon sizes
 * in rem, so scaling the root font-size scales the whole UI consistently.
 * Persisted in localStorage and applied to <html>.
 */
export type FontScale = 'normal' | 'large' | 'xlarge';

const KEY = 'snxt_font_scale';

export const FONT_SCALE_PCT: Record<FontScale, string> = {
  normal: '100%',
  large: '112.5%',
  xlarge: '125%',
};

export function getFontScale(): FontScale {
  try {
    const v = localStorage.getItem(KEY);
    if (v === 'large' || v === 'xlarge' || v === 'normal') return v;
  } catch {
    /* no storage (SSR/tests) */
  }
  return 'normal';
}

export function applyFontScale(scale: FontScale): void {
  if (typeof document !== 'undefined' && document.documentElement) {
    document.documentElement.style.fontSize = FONT_SCALE_PCT[scale];
  }
}

export function setFontScale(scale: FontScale): void {
  try {
    localStorage.setItem(KEY, scale);
  } catch {
    /* ignore */
  }
  applyFontScale(scale);
}
